import React, { Fragment, FC, memo } from 'react';
import { useSelector } from 'react-redux';
import LazyLoader from 'react-lazyload';

import { Campaign } from '@shared/types/mylounge';
import {
    getClientDeviceWidth,
    getClientDeviceHeight,
} from '@client/redux/modules/clientDevice/selectors';

import { Showstopper } from '@browsing/get-inspired';
import OpenCampaign from './open-campaign';
import * as S from './mobile-campaigns.styles';
import { ShowstopperContent } from '../showstopper';

interface Props {
    campaigns: Campaign[];
    showstopper?: ShowstopperContent;
    isPlusEnabled: boolean;
}

export const MobileCampaigns: FC<Props> = ({ campaigns, showstopper, isPlusEnabled }) => {
    const width = useSelector(getClientDeviceWidth);
    const height = useSelector(getClientDeviceHeight);

    if (!campaigns.length) {
        // TODO: return valid translated text
        return null;
    }

    const imgRatio = 0.58;
    const normalHeight = width * imgRatio;

    return (
        <S.Container id="campaigns-open">
            {campaigns.map((campaign, index) => (
                <Fragment key={campaign.campaignId}>
                    {showstopper?.position === index && (
                        <Showstopper
                            title={showstopper.title}
                            content={showstopper.content}
                            media={showstopper.media}
                            carouselItems={showstopper.campaigns}
                        />
                    )}
                    <LazyLoader offset={height} height={normalHeight} key={campaign.campaignId}>
                        <S.CampaignContainer>
                            <OpenCampaign
                                key={campaign.campaignId}
                                campaign={campaign}
                                index={index}
                                minHeight={normalHeight}
                                isPlusEnabled={isPlusEnabled}
                            />
                        </S.CampaignContainer>
                    </LazyLoader>
                </Fragment>
            ))}
        </S.Container>
    );
};

export default memo(MobileCampaigns);
